import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { CarList } from '../components/CarList';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button/Button';
import Heading from '../components/heading';

export default function CarAdmin() {
  return (
    <Layout>
      {/* Responsive container */}
      
       <Heading text="Car Administration" />
        
        <CarList />
      
    </Layout>
  );
}